import exp from 'constants';

type envType = string | undefined;
export const ENV: string = process.env.REACT_APP_API_ENV || 'dev';

// API 接口
const API_HOST: Map<string, string> = new Map([
	['dev', 'https://dev-gateway.fxqifu.net/pangu'],
	['qa', 'https://qa-gateway.fxqifu.net/pangu'],
	['prod', 'https://gateway.fxqifu.net/pangu']
]);

const PROGRAM: Map<string, string> = new Map([
	['dev', 'https://dev-preview.fleshopy.com'],
	['qa', 'https://qa-preview.fleshopy.com'],
	['prod', 'https://preview.fleshopy.com']
]);

const PAY: Map<envType, string> = new Map([
	['dev', 'http://dev-pay.elebuys.com/pay'],
	['qa', 'http://qa-pay.elebuys.com/pay'],
	['prod', 'https://pay.elebuys.com/pay']
]);

export const SHOP_MOBILE: Map<envType, string> = new Map([
	['dev', 'http://dev-preview.fleshopy.com/index'],
	['qa', 'https://qa-preview.fleshopy.com/index'],
	['prod', 'https://preview.fleshopy.com/index']
]);

export const manager30: Map<envType, string> = new Map([
	['dev', 'http://manager.koudaiqifu.cn/'],
	['qa', 'http://manager.koudaiqifu.cn/'],
	['test', 'http://manager.koudaiqifu.cn/'],
	['prod', 'https://manager.fxqifu.com/']
]);

// 装修
export const FIMENT: Map<envType, string> = new Map([
	['dev', ''],
	['qa', ''],
	['test', ''],
	['prod', '']
]);

// 装修预览
export const FITMENT_PREVIEW: Map<envType, string> = new Map([
	['dev', 'https://dev.carpunion.com'],
	['qa', 'https://qa.carpunion.com'],
	['test', 'https://qa.carpunion.com'],
	['prod', 'https://carpunion.com']
]);

// 装修
export const FIMENT_WL: Map<envType, string> = new Map([
	['dev', ''],
	['qa', ''],
	['test', ''],
	['prod', '']
]);

// 装修预览
export const FITMENT_PREVIEW_WL: Map<envType, string> = new Map([
	['dev', 'https://dev.wowcarp.com'],
	['qa', 'https://qa.wowcarp.com'],
	['test', 'https://qa.wowcarp.com'],
	['prod', 'https://console.wowcarp.com']
]);

export const MAIN_HOST = API_HOST.get(ENV);

export const PROGRAM_HOST = PROGRAM.get(ENV);

export const PAY_HOST = PAY.get(ENV);

export const SHOP_MOBILE_HOST = SHOP_MOBILE.get(ENV);

export const manager30Url = manager30.get(ENV);

export const FIMENT_HOST = FIMENT.get(ENV);

export const FITMENT_PREVIEW_HOST = FITMENT_PREVIEW.get(ENV);

export const FIMENT_HOST_WL = FIMENT_WL.get(ENV);

export const FITMENT_PREVIEW_HOST_WL = FITMENT_PREVIEW_WL.get(ENV);
